var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.982 11.55C15.736 10.802 16.204 9.767 16.204 8.625C16.204 6.351 14.353 4.5 12.079 4.5H8.833H8.831H7.112C6.698 4.5 6.362 4.836 6.362 5.25C6.362 5.664 6.698 6 7.112 6H8.078L8.051 18H7.125C6.711 18 6.375 18.336 6.375 18.75C6.375 19.164 6.711 19.5 7.125 19.5H8.797H8.799H13.456C15.73 19.5 17.581 17.649 17.581 15.375C17.581 13.641 16.502 12.159 14.982 11.55ZM12.079 6C13.526 6 14.704 7.178 14.704 8.625C14.704 10.072 13.526 11.25 12.079 11.25H9.567L9.579 6H12.079ZM13.456 18H9.551L9.563 12.75H13.456C14.903 12.75 16.081 13.928 16.081 15.375C16.081 16.822 14.903 18 13.456 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.717452ed7d91398afb8d0d0dbae12ed3.svg";
export { ForwardRef as ReactComponent };